import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";

import { DocumentRequest } from "../DocumentRequest";
import { RaffleIcon } from "../../../assets/image/RaffleIcon";
import { RebootIcon } from "../../../assets/image/RebootIcon";
import { ArrowLeftIcon } from "../../../assets/image/ArrowLeftIcon";
import {ENG_LANGUAGE, MONTH_ENG_LANGUAGE, MONTH_SRB_LANGUAGE, REFINE_OPTIONS} from "../../../utils/variables";
import {
  deleteMultiDocuments,
  getNotificationsDocument,
} from "../../../api/documentApi";
import { useInterviewStore } from "../../../store/useInterviewStore";
import { DocumentMessage } from "../DocumentMessage";

export function DocumentRequestContent() {
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const [isCheck, setIsCheck] = useState(true);
  const [documentData, setDocumentData] = useState([]);
  const [view, setView] = useState("");
  const [deleteList, setDeleteList] = useState([]);
  const [recived, setRecived] = useState("");
  const [isActive, setIsActive] = useState(false);

  const { refine, setRefine, resetInterviewState } = useInterviewStore();

  useEffect(() => {
    return () => {
      resetInterviewState();
    };
  }, []);

  const navigate = useNavigate();
  const slugData = useParams();
  let data = slugData.name;

  const [profileSection, setProfileSection] = useState(
      localStorage.getItem("side") && localStorage.getItem("side") != ""
          ? localStorage.getItem("side")
          : ""
  );

  const fetchDocumentData = async () => {
    setDocumentData([]);

    try {
      const result = await getNotificationsDocument(refine);
      setDocumentData(result.data);
    } catch (error) {
      console.error("Error fetching document data:", error);
    }
  };

  useEffect(() => {
    if (isCheck) {
      fetchDocumentData();
      setIsCheck(false);
    }

    setView(data ? data : "");
  }, [isCheck, documentData, data, slugData]);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setRecived("text-refine");
    }
  }, []);

  const handleSelectElement = () => {
    const ele = document.getElementsByName("chk");
    documentData.map((data) => {
      deleteList.push(data.id);
    });
    for (let i = 0; i < ele.length; i++) {
      if (ele[i].type == "checkbox") ele[i].checked = true;
    }
  };

  const handleDeselectElement = () => {
    const ele = document.getElementsByName("chk");
    for (let i = 0; i < ele.length; i++) {
      if (ele[i].type == "checkbox") ele[i].checked = false;
    }
    setDeleteList([]);
  };

  const handleDeleteSelect = (a) => {
    let sum = false;
    deleteList.map((e) => {
      if (e == a) {
        sum = true;
        const index = deleteList.indexOf(a);
        if (index > -1) {
          deleteList.splice(index, 1);
        }
      }
    });
    if (sum == false) {
      deleteList.push(a);
    }
  };

  const month =
      language === ENG_LANGUAGE ? MONTH_ENG_LANGUAGE : MONTH_SRB_LANGUAGE;

  const handleDeleteMultiDocuments = async () => {
    try {
      const result = await deleteMultiDocuments(deleteList);
      fetchDocumentData();
    } catch (error) {
      console.error("Error deleting documents:", error);
    }
  };

  const handleRefineDay = (e) => {
    setRefine({
      threedays: e == "3" ? true : "",
      withinweek: e == "7" ? true : "",
      twofourday: e == "24" ? true : "",
      withinmonth: e == "30" ? true : "",
    });
    setIsCheck(true);
  };

  return (
    <div>
      {view == "" ? (
        <>
          <div class="main-header">
            <h2 className="border">{t("document-requests")}</h2>
            <div class="mail-header-bar">
              <p>
                {documentData.length} {t("text-requests")}
              </p>
              <div class="btn-group flex">
                {t("text-refine")}
                <div className="select">
                  <label onClick={(e) => setIsActive(!isActive)}>
                    {t(recived)}
                    <span>
                      <img src="/images/done_a.svg" />
                    </span>
                  </label>
                  {isActive && (
                    <ul>
                      {REFINE_OPTIONS.map((option) => (
                        <li
                          key={option.label}
                          onClick={() => {
                            setRecived(t(option.label));
                            handleRefineDay(option.value);
                            setIsActive(!isActive);
                          }}
                        >
                          {t(option.label)}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div class="mail-option">
              <div class="chk-all">
                <input
                  type="checkbox"
                  class="mail-radio mail-group-radio"
                  name="chk"
                  id="checkbox_id"
                  onClick={(e) => {
                    if (e.target.checked) {
                      handleSelectElement();
                    } else {
                      handleDeselectElement();
                    }
                  }}
                />
                <span className="circle"></span>
                <label for="checkbox_id">{t("select-all")}</label>
              </div>
              <div class="right-side-btn">
                <div
                  class="delete-btn"
                  onClick={(e) => handleDeleteMultiDocuments()}
                >
                  <a href="#">
                    <RaffleIcon />
                    <span> {t("text-delete")}</span>
                  </a>
                </div>
                <div class="refresh-btn" onClick={(e) => fetchDocumentData()}>
                  <a href="#">
                    <RebootIcon />
                  </a>
                  <span>{t("text-refresh")}</span>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-inbox table-hover hovertable">
            <tbody>
              {documentData.map((data) => {
                return (
                  <DocumentMessage
                    key={data.id}
                    data={data}
                    handleDeleteSelect={handleDeleteSelect}
                    setView={setView}
                    setProfileSection={setProfileSection}
                    month={month}
                  />
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <div class="main-header">
          <button
            onClick={(e) => {
              navigate("/search-providers/" + slugData.id);
              setView("");
            }}
          >
            <ArrowLeftIcon />
            {t("text-back")}
          </button>
          <DocumentRequest id={view} />
        </div>
      )}
    </div>
  );
}
